import React, { FunctionComponent, useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { Icon } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { pathOr } from 'ramda';

import { ClassProp } from 'helpers/types';
import { GET_COUNT } from 'components/Header/components/Filters/Filters.queries';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const styles = {
  button: {
    backgroundColor: '#683caf !important',
    border: 'none',
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    display: 'flex !important',
    fontSize: '.8rem',
    margin: '.25rem 0 .25rem 0.75rem !important',
    opacity: 1,
    padding: '0.5rem 1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.25rem !important',

    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  label: {
    fontSize: '.5rem !important',
    backgroundColor: '#fff !important',
    color: '#000 !important',
    alignSelf: 'center',
    marginRight: '.25rem !important',
  },
};
const showLabel = (count: number, classes: Styles) => <Icon name="filter" />;

const showFilterButton = (toggle: any, count: number, classes: Styles) => (
  <button onClick={toggle} className={classes.button}>
    {showLabel(count, classes)}
    Filters
  </button>
);

const FilterButton: FunctionComponent<Props> = ({ classes }) => {
  const client = useApolloClient();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const filterCountPayload = useQuery(GET_COUNT);
  const count = pathOr(0, ['data', 'filterCount'], filterCountPayload);

  useEffect(() => {
    client.writeData({ data: { filtersIsOpen: isOpen } });
  }, [isOpen]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const renderFilterButton = () => showFilterButton(toggle, count, classes);

  return (
    <Switch>
      <Route
        exact
        render={renderFilterButton}
        path={[
          '/merchant/:merchantId/overview/:merchantName',
          '/:merchantName/overview',
        ]}
      />
    </Switch>
  );
};

export default withStyles(styles)(FilterButton);
